<template>
    <div id="edit">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-th-list"></i>Premade Categories</div>
        </div>
        <hr>
        <form class="box">
            <div class="columns is-multiline">

<!--                <div class="column is-3">
                    <div class="field">
                        <bulma-input name="alias" v-model="magicWord.alias" rules="required" :placeholder="'{{alias}}'"/>
                    </div>
                </div>-->
                <div class="column is-4">
                    <div class="field">
                        <bulma-input name="name" v-model="magicWord.name" rules="required" placeholder="Name"/>
                    </div>
                </div>
                <div class="column is-4">
                    <div class="field">
                        <bulma-input name="title" v-model="magicWord.title" rules="required" placeholder='Title'/>
                    </div>
                </div>
                <div class="column is-4">
                    <div class="field">
                        <bulma-input name="placeholder" v-model="magicWord.placeholder" rules="required" placeholder='Placeholder'/>
                    </div>
                </div>
                <div class="column is-6">
                    <div class="field">
                        <bulma-input name="description" v-model="magicWord.description" rules="required" placeholder='Description'/>
                    </div>
                </div>
                <div class="column is-4">
                    <div class="field">
                        <multiselect v-model="magicWord.schools" label="name" name="schools" track-by="name" :options="schools" :multiple="true" placeholder="Choose schools"></multiselect>
                    </div>
                </div>
                <div class="column is-2">
                    <div class="field">
                        <multiselect v-model="magicWord.type" name="types" :options="['input', 'textarea']" :multiple="false" placeholder="Field type"></multiselect>
                    </div>
                </div>
            </div>
            <div class="columns is-multiline">
                <div class="column is-2">
                    <loading-button v-bind:loading="loading" color="is-info" @click="save()">Save</loading-button>
                </div>
                <div class="column is-2 is-offset-8 is-pulled-right">
                    <a href="javascript:history.go(-1)" class="button is-block">
                        Back
                    </a>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import _ from 'lodash'

    export default {
        name: 'magic-word-edit',
        components: {},
        props: {},
        data() {
            return {
                loading: false,
                schools: [],
                magicWord: {schools : []},
            }
        },
        created(){
            this.loadSchools();
        },
        methods: {
            getMagicWord(id){
                this.magicWordRepo.get(id).then(response => {
                    this.magicWord = response.data.data;
                });
            },
            loadSchools(){
                this.loading = true;
                this.schoolRepo.all().then(response => {
                    this.schools = response.data.data;
                    this.loading = false;
                    this.getMagicWord(this.$route.params.id);

                }).catch((response) =>{
                    this.loading = false;
                    return Promise.reject(response);
                });
            },
            save(){
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        let self = this;
                        this.loading = true;

                        this.magicWordRepo.update(this.magicWord.id, this.magicWord).then(function (response) {
                            self.loading = false;
                            self.$toast.success(response.data.message);
                            self.$router.push('/dashboard/magic-words');
                        }).catch(function(response){
                            self.loading = false;
                            return Promise.reject(response);
                        });
                    }
                });

            },
        },
        watch: {

        }

    }
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/magic-words/Edit.vue